import { Badge, Space, Tab } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { useCorrectionTabVisitTracker } from '../../../../hooks/useCorrectionTabVisitTracker'
import { getCorrectionTabTitle } from '../../utils/getCorrectionTabTitle'

interface CorrectionTabProps {
  correctionNo: number
  correctionVatDeclarationId: string
  isActive: boolean
  numOfCorrections: number
}

export const CorrectionTab = ({
  correctionNo,
  correctionVatDeclarationId,
  isActive,
  numOfCorrections,
}: CorrectionTabProps) => {
  const { t } = useTranslation()
  const { shouldShowBadge } = useCorrectionTabVisitTracker(correctionVatDeclarationId, isActive)

  const tabTitle = getCorrectionTabTitle({ correctionNo, numOfCorrections, t })

  return (
    <Tab key={correctionVatDeclarationId} active={isActive} to={correctionVatDeclarationId}>
      {tabTitle}
      <Space size="s8" horizontal />
      {shouldShowBadge && <Badge>{t('vat_declarations.corrections_tab.badge')}</Badge>}
    </Tab>
  )
}
